import { createContext } from 'react';
import {
    PART_TIME_OPTION_FULL,
    PART_TIME_OPTION_TEMP,
    PART_TIME_OPTION_INDEF,
    RIDER_AVAILABILITY_NOT_AVAILABLE,
    RIDINGS_PER_WEEK_MODERATE,
    RIDINGS_PER_WEEK_ENOUGHT,
    RIDINGS_PER_WEEK_FULL,
    RIDINGS_PER_WEEK_FLEXIBLE,
    HORSE_AVAILABILITY_PART_TIME_OPTION_FROM_SPEC_DAY,
} from '../../marketplace-custom-config';

export const MatchingDialogContext = createContext(null);

export const categories = [
    {
        id: 'high',
        label: 'Hoch',
    },
    {
        id: 'mid',
        label: 'Mittel',
    },
    {
        id: 'low',
        label: 'Gering',
    },
];

export const availabilityTerms = {
    [PART_TIME_OPTION_FULL]: () => 'Ich bin offen',
    [PART_TIME_OPTION_TEMP]: () => 'Befristet',
    [HORSE_AVAILABILITY_PART_TIME_OPTION_FROM_SPEC_DAY]: () => 'Befristet',
    [PART_TIME_OPTION_INDEF]: () => 'Unbefristet',
};

export const frequencyTerms = {
    [RIDINGS_PER_WEEK_MODERATE]: ridingsPerWeek => `${ridingsPerWeek} Tage pro Woche`,
    [RIDINGS_PER_WEEK_ENOUGHT]: ridingsPerWeek => `${ridingsPerWeek} Tage pro Woche`,
    [RIDINGS_PER_WEEK_FULL]: ridingsPerWeek => `${ridingsPerWeek} Tage pro Woche`,
    [RIDINGS_PER_WEEK_FLEXIBLE]: () => 'Flexibel',
    [RIDER_AVAILABILITY_NOT_AVAILABLE]: () => 'Nicht Verfügbar',
};
